// extracted by mini-css-extract-plugin
module.exports = {"searchInputContainer":"Header_searchInputContainer__Cf7d_","searchInput":"Header_searchInput__186o1","clear":"Header_clear___c5pB","separator":"Header_separator__KMPF4"};